import { getConstraint } from "../services/constraintsService";

export const parseReportResults = (asset, clientSettings) => {
  const results = [];

  clientSettings.filterResults.forEach((category) => {
    category.info.forEach((res) => {
      if (res.options) {
        res.options.forEach((o) => {
          const value = res.season ? "All" + o.value : o.value;
          results.push({
            category: value,
            constraint: getConstraint(asset, value),
          });
        });
      } else {
        const value = res.season ? "All" + res.value : res.value;
        if (asset[value]) {
          results.push({
            category: res.value,
            constraint: getConstraint(asset, value),
          });
        }
      }
    });
  });

  return results;
};
